import React from 'react';

// Hooks
import { useUser } from 'Shared/utils/hooks/use-user';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as ReviewFormHelpers from 'Shared/model_helpers/ReviewForm.helper';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Components
import { WpText } from 'Wpds/components/text';
import { WpAvatar, WpAvatarEmpty } from 'Wpds/components/avatar';
import ReviewQuestion from '../../ThreeSixtyReviewPartials/ReviewQuestion/ReviewQuestion';

// Styles
import './SharePageQustionResponseItem.scss';

type Props = {
  review;
  reviewForm;
  question;
};

const SharePageQustionResponseItem = ({ review, reviewForm, question }: Props) => {
  const { slug: currenUserSlug } = useCurrentUser();
  const userSlug = ReviewFormHelpers.getUserSlug(reviewForm);
  const receiverSlug = ReviewsHelpers.getReceiverSlug(review);
  const isSelfReview = userSlug === receiverSlug;

  const isPeerReviewSharedAnonymously = ReviewsUtils.isFeedbackSharedAnonymously({ review });
  const isCurrentUserReceiver = receiverSlug === currenUserSlug;

  const { user: formUser } = useUser({ slug: userSlug });

  const formUserName =
    isCurrentUserReceiver && isPeerReviewSharedAnonymously && !isSelfReview ? 'Anonymous' : formUser.fullName;

  const baseClassName = 'SharePageQustionResponseItem';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__user`}>
        <div className={`${baseClassName}__user__avatar`}>
          {isCurrentUserReceiver && isPeerReviewSharedAnonymously && !isSelfReview ? (
            <WpAvatarEmpty size="sm" />
          ) : (
            <WpAvatar avatar={formUser.avatar} size="sm" />
          )}
        </div>
        <WpText tag="span" variant="bodyMd" bold>
          {formUserName}
          {isSelfReview && `  (Self Review)`}
        </WpText>
      </div>
      <ReviewQuestion
        question={question}
        slimVersion
        answers={ReviewFormHelpers.getAnswers(reviewForm)?.toJS() || []}
        formData={ReviewFormHelpers.getFormData(reviewForm)?.toJS() || {}}
      />
    </div>
  );
};

export default SharePageQustionResponseItem;
